<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Loader" });
import "tailwindcss/tailwind.css";
import { LOADERS } from "../../stores/loading.js";
</script>

{#if Array.isArray($LOADERS) && $LOADERS.length > 0}
    <div class = 's8-loading'></div>
{/if}

<style>

    @keyframes movingLine {
        0% {
            opacity: 0;
            width: 0;
        }

        33.3%, 66% {
            opacity: 0.8;
            width: 100%;
        }

        85% {
            width: 0;
            left: initial;
            right: 0;
            opacity: 1;
        }

        100% {
            opacity: 0;
            width: 0;
        }
    }

    div.s8-loading {
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        height: 5px;
        z-index: 50;
    }

    div.s8-loading:after {
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: 100%;
            height: 100%;

            background-color: rgba(31,71,48, 1);
            content: '';
            animation: movingLine 2.4s infinite ease-in-out;
        }</style>